<!-- Enhanced Report Header with Glass Morphism Effect -->
<div class="report-header bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 
            backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 px-6 py-4 rounded-t-lg shadow-sm">
    <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
            <a [routerLink]="['/main/reports']" class="back-icon group flex items-center justify-center w-10 h-10 rounded-full 
                      bg-white dark:bg-gray-700 shadow-md hover:shadow-lg transition-all duration-300 
                      hover:scale-110 border border-gray-200 dark:border-gray-600">
                <i class="pi pi-arrow-left text-gray-600 dark:text-gray-300 group-hover:text-blue-600 
                         dark:group-hover:text-blue-400 transition-colors duration-200"></i>
            </a>
            <div class="flex flex-col">
                <h1 class="font-bold text-xl text-gray-900 dark:text-white mb-0">{{ title }}</h1>
                <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Comprehensive data overview</p>
            </div>
        </div>
        <div *ngIf="slug != 'qualified-leads'" class="flex space-x-3">
            <button pButton label="Filter" icon="pi pi-filter" (click)="openBulkFilter()" class="p-button-outlined p-button-sm bg-white dark:bg-gray-700 border-gray-300 
                           dark:border-gray-600 hover:bg-blue-50 dark:hover:bg-gray-600 
                           transition-all duration-200 shadow-sm hover:shadow-md">
            </button>
            <button pButton icon="pi pi-download" class="p-button-outlined p-button-sm bg-white dark:bg-gray-700 border-gray-300 
                           dark:border-gray-600 hover:bg-green-50 dark:hover:bg-gray-600 
                           transition-all duration-200 shadow-sm hover:shadow-md" pTooltip="Export Data"
                tooltipPosition="bottom">
            </button>
        </div>
    </div>
</div>

<!-- Enhanced Loader with Pulse Animation -->
<!-- <div *ngIf="initialLoad || isDataLoading"
    class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mx-6 mt-4 p-6">
    <div class="flex items-center justify-center space-x-3 mb-4">
        <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        <span class="text-gray-600 dark:text-gray-300 font-medium">Loading your data...</span>
    </div>
    <p-progressBar mode="indeterminate" class="custom-progress-bar"></p-progressBar>
</div> -->

<!-- Enhanced PrimeNG Table with Modern Styling -->
<div
    class="table-container rounded-[20px] mx-6 mt-4 bg-white dark:bg-gray-800  shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
    <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRows" [lazy]="true"
        (onLazyLoad)="loadData($event)" [loading]="isDataLoading" styleClass="beautiful-table" [scrollable]="true"
        scrollHeight="calc(92vh - 150px)" [resizableColumns]="true"
        [rowsPerPageOptions]="totalRows > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <ng-template pTemplate="header">
            <tr class="bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800">
                <th class="table-header">
                    <i class="pi pi-user mr-2 text-blue-600"></i>Contact Name
                </th>
                <th class="table-header">
                    <i class="pi pi-users mr-2 text-green-600"></i>Lead Owner
                </th>
                <th class="table-header">
                    <i class="pi pi-external-link mr-2 text-purple-600"></i>Source
                </th>
                <th class="table-header">
                    <i class="pi pi-calendar mr-2 text-orange-600"></i>Created At
                </th>
                <th class="table-header">
                    <i class="pi pi-envelope mr-2 text-red-600"></i>Email
                </th>
                <th class="table-header">
                    <i class="pi pi-phone mr-2 text-indigo-600"></i>Phone
                </th>

                <th class="table-header">
                    <i class="pi pi-tag mr-2 text-pink-600"></i>Type
                </th>



                <th class="table-header">
                    <i class="pi pi-circle mr-2 text-emerald-600"></i>Status
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-element let-rowIndex="rowIndex">
            <tr class="table-row hover:bg-blue-50 dark:hover:bg-gray-700 transition-all duration-200"
                [class.even-row]="rowIndex % 2 === 0">

                <!-- Contact Name with Avatar -->
                <td class="table-cell">
                    <div class="flex items-center space-x-3">
                        <div class="flex-shrink-0 h-8 w-8 bg-gradient-to-br from-blue-400 to-blue-600 
                                    rounded-full flex items-center justify-center text-white text-sm font-semibold">
                            {{ getInitials(element) }}
                        </div>
                        <div class="font-medium text-gray-900 dark:text-white">
                            {{ getName(element) || 'N/A' }}
                        </div>
                    </div>
                </td>

                <!-- Lead Owner with Badge -->
                <td class="table-cell">
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium 
                                 bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100">
                        {{ getOwnerName(element?.user) }}
                    </span>
                </td>

                <!-- Source with Enhanced Styling -->
                <td class="table-cell">
                    <img [src]="getLeadSourceImg(element['source'])" class="h-[33px] w-[30px] object-contain ml-4" />
                </td>

                <!-- Created At with Time Badge -->
                <td class="table-cell">
                    <div class="flex flex-col">
                        <span class="text-sm font-medium text-gray-900 dark:text-white">
                            {{ element.createdAt | date:'MMM dd, yyyy' }}
                        </span>
                        <span class="text-xs text-gray-500 dark:text-gray-400">
                            {{ element.createdAt | date:'shortTime' }}
                        </span>
                    </div>
                </td>

                <!-- Contact Email with Link -->
                <td class="table-cell">
                    <a *ngIf="element.email" [href]="'mailto:' + element.email" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 
                              underline decoration-dotted hover:decoration-solid transition-all duration-200 text-sm">
                        {{ element.email }}
                    </a>
                    <span *ngIf="!element.email" class="text-gray-400 dark:text-gray-500 italic">N/A</span>
                </td>

                <!-- Contact Phone with Link -->
                <td class="table-cell">
                    <a *ngIf="element.phone" [href]="'tel:' + element.phone" class="text-green-600 hover:text-green-800 dark:text-green-400 dark:hover:text-green-300 
                              font-mono text-sm hover:underline transition-all duration-200">
                        {{ element.phone }}
                    </a>
                    <span *ngIf="!element.phone" class="text-gray-400 dark:text-gray-500 italic">N/A</span>
                </td>

                <!-- Organization with Icon -->
                <td class="table-cell">
                    <div class="flex items-center space-x-2" *ngIf="element.lead_type">
                        <span class="font-medium text-gray-900 dark:text-white">
                            {{ element.lead_type }}
                        </span>
                    </div>
                    <span *ngIf="!element.lead_type" class="text-gray-400 dark:text-gray-500 italic">N/A</span>
                </td>


                <!-- Status with Dynamic Color -->
                <td class="table-cell">
                    <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px] font-medium"
                        [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                        [style.borderColor]="getStatusColor(element['lead_status'])"
                        [style.color]="getStatusColor(element['lead_status'])" style="font-weight: 500;">
                        <div style="margin-top: 2px;">
                            <svg width="25px" height="25px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                <g [attr.stroke]="getStatusColor(element['lead_status'])" stroke-width="3" fill="none"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path
                                        d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                                    </path>
                                    <polyline points="21.0037832 16.5969533 17 21 14.4906972 18.5114193"></polyline>
                                </g>
                            </svg>
                        </div>
                        {{
                        element['lead_status'] || 'N/A'
                        }}
                    </div>
                </td>
            </tr>
        </ng-template>

        <!-- Empty State Template -->
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="10" class="text-center py-16">
                    <div class="flex flex-col items-center space-y-4">
                        <i class="pi pi-inbox text-6xl text-gray-300 dark:text-gray-600"></i>
                        <h3 class="text-lg font-medium text-gray-900 dark:text-white">No data found</h3>
                        <p class="text-gray-500 dark:text-gray-400">Try adjusting your filters or check back later.</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- Enhanced Sidebar with Modern Filter Design -->
<p-drawer [(visible)]="isOpen" position="right" [baseZIndex]="10000" styleClass="modern-drawer">
    <ng-template pTemplate="header">
        <div class="flex items-center justify-between w-full">
            <div class="flex items-center space-x-3">
                <div class="flex-shrink-0 w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-lg 
                            flex items-center justify-center">
                    <i class="pi pi-filter text-blue-600 dark:text-blue-400"></i>
                </div>
                <div>
                    <h3 class="text-lg font-semibold text-white mb-0">Advanced Filters</h3>
                    <p class="text-sm text-white">Refine your data view</p>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="space-y-6 mt-6">
        <!-- Today's Filter -->
        <div *ngIf="slug == 'todays-leads' || slug == 'call-log-report' || slug == 'email-log-report'"
            class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                <i class="pi pi-calendar mr-2"></i>Time Period
            </label>
            <p-select [options]="todaysFilter" optionLabel="label" (ngModelChange)="onTodayFilterChange($event)"
                optionValue="value" [(ngModel)]="selectedTodayFilter" placeholder="Select time period"
                styleClass="w-full modern-dropdown">
            </p-select>
        </div>

        <!-- Lead Status Filter -->
        <div *ngIf="slug == 'leads-by-status'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                <i class="pi pi-circle mr-2"></i>Lead Status
            </label>
            <p-multiselect [options]="leadStatusList" [(ngModel)]="selectedLeadStatusFilter" placeholder="Select Lead Status" optionLabel="label" display="chip" class="w-full" />
        </div>

        <!-- Lead Source Filter -->
        <div *ngIf="slug == 'leads-by-source'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                <i class="pi pi-filter mr-2"></i>Lead Source
            </label>
            <p-multiselect [options]="leadSourceList" [(ngModel)]="selectedLeadSourceFilter" placeholder="Select Lead Source" optionLabel="label" display="chip" class="w-full" />
        </div>

        <div *ngIf="slug == 'leads-by-ownership' || slug == 'call-log-report' || slug == 'email-log-report'" class="filter-section">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                <i class="pi pi-user mr-2"></i>Lead Owner
            </label>
            <p-multiselect [options]="leadOwnerList" [(ngModel)]="selectedLeadOwnerFilter" placeholder="Select Lead Owner" optionLabel="name" display="chip" class="w-full" />
        </div>

        <!-- Filter Actions -->
        <div class="flex flex-col space-y-3 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p-button label="Apply Filters" icon="pi pi-check" (click)="applyBulkFilter()" [loading]="filterLoading"
                styleClass="p-button-primary w-full modern-button">
            </p-button>
            <!-- <p-button label="Clear Filters" icon="pi pi-times" styleClass="p-button-outlined w-full modern-button">
            </p-button> -->
        </div>
    </div>
</p-drawer>